<script setup lang="ts">
    withDefaults(
        defineProps<{
            json?: string;
            title?: string;
            subtitle?: string;
            redirectText?: string;
            redirectPath?: string;
            lottieHeight?: string;
        }>(),
        {
            json: 'https://shared-assets.trustup.io/lottie/success2.json',
            lottieHeight: 'h-[300px]',
        }
    );

    const emit = defineEmits<{
        (e: 'close'): void;
    }>();
</script>

<template>
    <div :class="$theme('modal.padding')">
        <div
            v-if="title"
            :class="$theme('modal.title.container')"
        >
            <h2 :class="$theme('modal.title.text', 'mb-4')">
                {{ title }}
            </h2>
            <h3
                v-if="subtitle"
                :class="$theme('modal.title.subtext')"
            >
                <p v-html="subtitle"></p>
                <NuxtLink
                    v-if="redirectText && redirectPath"
                    :to="redirectPath"
                    class="text-sm font-medium hover:underline"
                    @click="emit('close')"
                    >{{ redirectText }}
                </NuxtLink>
            </h3>
        </div>
        <div class="flex justify-center mb-12">
            <div
                class="max-w-[300px]"
                :class="lottieHeight"
            >
                <Lottie :json="json" />
            </div>
        </div>
        <slot></slot>
    </div>
</template>
